export const PREMIUM_TYPE_BASIC = 'free';
export const PREMIUM_TYPE_STARTER = 'starter';
export const PREMIUM_TYPE_PRO = 'pro';
export const PREMIUM_TYPE_ULTIMATE = 'ultimate';